var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowcasePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1892 2.04134L5.53725 5.88529C4.64733 6.28082 4.06641 7.17074 4.06641 8.14718V13.9564C4.06641 20.8162 8.81265 27.231 15.1904 28.7884C21.5682 27.231 26.3144 20.8162 26.3144 13.9564V8.14718C26.3144 7.17074 25.7335 6.28082 24.8436 5.88529L16.1916 2.04134C15.5612 1.75705 14.8196 1.75705 14.1892 2.04134ZM15.1904 15.18H23.8424C23.1873 20.2723 19.7883 24.8085 15.1904 26.2299V15.1924H6.53841V8.14718L15.1904 4.30322V15.18Z",
    fill: "#8F8F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcasePage);
export default __webpack_public_path__ + "static/media/ShowcasePage.e5df8ccc9e6c85fd0d697046d4d02d3a.svg";
export { ForwardRef as ReactComponent };